import React from 'react';
import { FormattedMessage } from 'react-intl';
import { END_OF_DAY_CATEGORY_VIEW_ID } from './view-id-constants';

export const EndOfDayCategory = {
  label: (
    <FormattedMessage
      defaultMessage='End of Day'
      description='End of Day category that appears in the left nav in the Shipments section'
      id='j/kPQ1'
    />
  ),

  id: END_OF_DAY_CATEGORY_VIEW_ID,
  navigationOverride: '/shipments/end-of-day',
};
